import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    cardDetail: [],
    reservationActivityLogsList: [],
    activityBookingId: 0,
};
const reservationViewSlice = createSlice({
  name: "reservationView",
  initialState: initialState,
  reducers: {
    cardDetailSuccess: (state, action) => {
      state.cardDetail = action.payload;
    },
    cardDetailFailed: (state, action) => {
      state.cardDetail = [];
    },
    reservationActivityLogsListSuccess: (state, action) => {
      state.reservationActivityLogsList = action.payload;
    },
    activityBookingIdSuccess: (state, action) => {
      state.activityBookingId = action.payload;
    },
  },
});

export const {
  cardDetailSuccess,
  cardDetailFailed,
  reservationActivityLogsListSuccess,
  activityBookingIdSuccess,
} = reservationViewSlice.actions;

export default reservationViewSlice.reducer;
